import React from 'react';
import Page from 'components/Page';
import Summary from './components/CampaignSummary';
import Tabs from './components/CampaignTabs';
import EditInfo from './components/EditCampaignInfo';
import EditAudience from './components/EditCampaignAudience';
import CampaignStatistics from './components/CampaignStatistics';
import TestCampaign from './components/TestCampaign';

function Campaign({ location, match }) {
  const campaignId = Number(match.params.id);
  const activeTab = location.pathname.split('/')[3];

  return (
    <Page>
      <Summary campaignId={campaignId} />

      <Tabs activeKey={activeTab} campaignId={campaignId} />

      <div hidden={activeTab !== 'info'}>
        <EditInfo campaignId={campaignId} />
      </div>

      <div hidden={activeTab !== 'audience'}>
        {activeTab === 'audience' && <EditAudience campaignId={campaignId} />}
      </div>

      <div hidden={activeTab !== 'statistics'}>
        <CampaignStatistics campaignId={campaignId} />
      </div>

      <div hidden={activeTab !== 'test'}>
        <TestCampaign campaignId={campaignId} />
      </div>
    </Page>
  );
}

export default Campaign;
